import { createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, renderSlot as _renderSlot, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = ["for"]
const _hoisted_2 = ["id", "checked", "disabled"]
const _hoisted_3 = { class: "text-left whitespace-pre-wrap" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("label", {
    for: _ctx.for_id,
    class: "flex items-center select-none"
  }, [
    _createElementVNode("input", {
      id: _ctx.for_id,
      hidden: "",
      type: "checkbox",
      checked: _ctx.checked,
      disabled: _ctx.isDisabled
    }, null, 8, _hoisted_2),
    _createElementVNode("span", {
      class: _normalizeClass(["block rounded-full border border-next-dark-gray mr-2 cursor-pointer shrink-0", [_ctx.checked ? 'border-next-orange bg-next-orange':'',_ctx.isDisabled?'border-next-gray-md-dark': '', _ctx.checkClass ]])
    }, null, 2),
    _createElementVNode("span", _hoisted_3, [
      _renderSlot(_ctx.$slots, "default")
    ])
  ], 8, _hoisted_1))
}